import React, { Component } from 'react';
import List from './List';
import './style.less';

class ReturnedMoney extends Component {
    state = {
        cur: 'quarter',
    }

    handleBtnClick = (cur) => {
        this.setState({ cur });
    }

    render() {
        const { cur } = this.state;
        //const{exportable}=this.props;
        const exportable = true;
        return (
            <div className="content">
                <div className="main">
                <div className="reportTitle">{this.props.title}</div>
                    <div className="main-content">
                        <div className="tab_flex">
                            <a onClick={() => this.handleBtnClick('quarter')} className={cur == 'quarter' ? 'curr' : ''} >
                                季度报告
                            </a>
                            <a onClick={() => this.handleBtnClick('Year')} className={cur == 'Year' ? 'curr' : ''} >
                                年度报告
                            </a>
                        </div>
                        { cur === 'quarter' && <List type={'quarter'}/> }
                        { cur === 'Year' && <List type={'Year'}/> }
                    </div>
                </div>
            </div>
        )
    }
}

export default ReturnedMoney;



// WEBPACK FOOTER //
// ./src/components/homePage/returnedMoney/index.js